let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j3ngh")).then(() => parcelRequire('6slG9'));